(function () {
  'use strict';

  function messageFor(field) {
    if (field.type === 'email') return 'Enter a valid email address.';
    return 'Complete this required field to continue.';
  }

  function setFieldError(field, message) {
    var error = field.parentElement.querySelector('[data-ae-field-error]');
    field.setAttribute('aria-invalid', 'true');
    if (error) {
      if (!error.id) error.id = field.id + '-error';
      error.textContent = message;
      error.hidden = false;
      field.setAttribute('aria-describedby', error.id);
    }
  }

  function clearFieldError(field) {
    var error = field.parentElement.querySelector('[data-ae-field-error]');
    field.removeAttribute('aria-invalid');
    if (error) {
      error.textContent = '';
      error.hidden = true;
      if (field.getAttribute('aria-describedby') === error.id) field.removeAttribute('aria-describedby');
    }
  }

  function validateStep(step) {
    var fields = step.querySelectorAll('[data-ae-required]');
    var invalid = [];

    fields.forEach(function (field) {
      if (field.validity.valid) {
        clearFieldError(field);
      } else {
        setFieldError(field, messageFor(field));
        invalid.push(field);
      }
    });

    return invalid;
  }

  function init(root) {
    if (root.dataset.aeQuoteReady === 'true') return;
    root.dataset.aeQuoteReady = 'true';

    var form = root.querySelector('#ContactForm');
    var confirmation = root.querySelector('[data-ae-quote-confirmation]');
    var storagePrefix = 'aeQuoteSubmission:';
    var storageKey = storagePrefix + (form ? form.id : 'ContactForm');
    var pendingKey = 'ae:quote-pending:' + (form ? form.id : 'ContactForm');
    var pendingMaxAge = 2 * 60 * 60 * 1000;

    function createEventId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return 'aeq-' + Date.now() + '-' + Math.random().toString(16).slice(2);
    }

    function savePendingConversion() {
      if (!form) return;
      try {
        window.sessionStorage.setItem(pendingKey, JSON.stringify({
          event_id: createEventId(),
          form_id: form.id,
          quote_type: root.dataset.variant || 'Unknown',
          submitted_at: Date.now()
        }));
      } catch (error) {
        return;
      }
    }

    function pendingConversion() {
      var pending = null;
      try {
        pending = JSON.parse(window.sessionStorage.getItem(pendingKey) || 'null');
      } catch (error) {
        return null;
      }

      if (
        !pending ||
        pending.form_id !== form.id ||
        typeof pending.submitted_at !== 'number' ||
        Date.now() - pending.submitted_at > pendingMaxAge
      ) {
        return null;
      }
      return pending;
    }

    function clearSuccessQuery() {
      if (!window.history || typeof window.history.replaceState !== 'function') return;
      try {
        var url = new URL(window.location.href);
        if (!url.searchParams.has('contact_posted')) return;
        url.searchParams.delete('contact_posted');
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      } catch (error) {
        return;
      }
    }

    function publishConfirmedConversion(pending) {
      var eventData = {
        event_id: pending.event_id,
        form_id: pending.form_id,
        quote_type: pending.quote_type,
        page_path: window.location.pathname,
        theme_id: window.Shopify && window.Shopify.theme ? String(window.Shopify.theme.id) : '',
        environment: 'storefront'
      };
      var attempts = 0;

      function publish() {
        if (typeof window.fbq !== 'function') {
          attempts += 1;
          if (attempts < 50) window.setTimeout(publish, 100);
          return;
        }

        try {
          window.fbq('track', 'Lead', {
            content_name: 'Custom order quote',
            content_category: 'Custom Orders',
            quote_type: eventData.quote_type,
            form_id: eventData.form_id
          }, {
            eventID: eventData.event_id
          });
        } catch (error) {
          return;
        }

        if (
          window.Shopify &&
          window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function'
        ) {
          try {
            var result = window.Shopify.analytics.publish('ae_awards:quote_submitted', eventData);
            if (result && typeof result.catch === 'function') result.catch(function () {});
          } catch (error) {}
        }

        try {
          window.sessionStorage.removeItem(pendingKey);
        } catch (error) {}
        clearSuccessQuery();
      }

      publish();
    }

    function savedSubmission() {
      try {
        var saved = window.sessionStorage.getItem(storageKey);
        return saved ? JSON.parse(saved) : null;
      } catch (error) {
        return null;
      }
    }

    function renderSubmission(submission) {
      var summary = root.querySelector('[data-ae-quote-submission-copy]');
      var list = root.querySelector('[data-ae-quote-submission-list]');
      if (!summary || !list || !submission || !Array.isArray(submission.fields) || !submission.fields.length) return;
      list.textContent = '';
      submission.fields.forEach(function (savedField) {
        var item = document.createElement('div');
        var term = document.createElement('dt');
        var description = document.createElement('dd');
        term.textContent = savedField.label;
        description.textContent = savedField.value;
        item.appendChild(term);
        item.appendChild(description);
        list.appendChild(item);
      });
      summary.hidden = false;
    }

    if (confirmation) {
      var pending = pendingConversion();
      if (pending) publishConfirmedConversion(pending);
      renderSubmission(savedSubmission());
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.requestAnimationFrame(function () {
        confirmation.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        confirmation.focus({ preventScroll: true });
      });
      return;
    }
    if (!form) return;

    function settleQuoteAnchor() {
      if (window.location.hash !== '#ae-quote-form') return;
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.requestAnimationFrame(function () {
        root.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        root.setAttribute('tabindex', '-1');
        root.focus({ preventScroll: true });
      });
    }

    if (document.readyState === 'complete') settleQuoteAnchor();
    else window.addEventListener('load', settleQuoteAnchor, { once: true });

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-ae-quote-step]'));
    var errors = root.querySelector('[data-ae-quote-client-errors]');
    var name = root.querySelector('#ContactForm-name');
    var email = root.querySelector('#ContactForm-email');
    var awardType = root.querySelector('#ContactForm-award-type');
    var phone = root.querySelector('#ContactForm-phone');
    var quantity = root.querySelector('#ContactForm-quantity');
    var needByDate = root.querySelector('#ContactForm-need-by-date');
    var details = root.querySelector('#ContactForm-order-details');
    var artwork = root.querySelector('#ContactForm-artwork');
    var recapName = root.querySelector('[data-ae-quote-recap-name]');
    var recapEmail = root.querySelector('[data-ae-quote-recap-email]');
    var recapAwardType = root.querySelector('[data-ae-quote-recap-award-type]');
    var recapPhone = root.querySelector('[data-ae-quote-recap-phone]');
    var recapQuantity = root.querySelector('[data-ae-quote-recap-quantity]');
    var recapDate = root.querySelector('[data-ae-quote-recap-date]');
    var recapDetails = root.querySelector('[data-ae-quote-recap-details]');
    var recapArtwork = root.querySelector('[data-ae-quote-recap-artwork]');
    var currentStep = 1;

    root.classList.add('ae-quote-form--enhanced');
    form.noValidate = true;

    function inputValue(field, fallback) {
      if (!field || !field.value.trim()) return fallback;
      return field.value.trim();
    }

    function artworkCount() {
      var value = artwork ? artwork.value.trim() : '';
      if (!value) return 0;

      try {
        var parsed = JSON.parse(value);
        if (Array.isArray(parsed)) return parsed.length;
        if (parsed && Array.isArray(parsed.files)) return parsed.files.length;
      } catch (error) {
        // Uploadcare normally stores a URL; JSON is supported as a safe fallback.
      }

      var groupCount = value.match(/~(\d+)(?:\/|$)/);
      if (groupCount) return Number(groupCount[1]);
      return 1;
    }

    function updateRecap() {
      var detailValue = inputValue(details, 'Not provided');
      var count = artworkCount();
      if (detailValue.length > 200) detailValue = detailValue.slice(0, 200).trimEnd() + '…';

      if (recapName) recapName.textContent = inputValue(name, 'Not provided');
      if (recapEmail) recapEmail.textContent = inputValue(email, 'Not provided');
      if (recapAwardType) recapAwardType.textContent = inputValue(awardType, 'Not provided');
      if (recapPhone) recapPhone.textContent = inputValue(phone, 'Not provided');
      if (recapQuantity) recapQuantity.textContent = inputValue(quantity, 'Not sure yet');
      if (recapDate) recapDate.textContent = inputValue(needByDate, 'Not provided');
      if (recapDetails) recapDetails.textContent = detailValue;
      if (recapArtwork) recapArtwork.textContent = count ? count + (count === 1 ? ' file' : ' files') : 'None — sending later';
    }

    function fieldLabel(field) {
      var label = field.id ? root.querySelector('label[for="' + field.id + '"]') : null;
      if (label) return label.textContent.replace(/\s+/g, ' ').replace(/\s*\*$/, '').replace(/\s+\(optional\)$/i, '').trim();
      return field.name.slice(8, -1).replace(/([a-z])([A-Z])/g, '$1 $2');
    }

    function saveSubmission() {
      updateRecap();
      var fields = [];
      form.querySelectorAll('[name^="contact["]').forEach(function (field) {
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
        var value = field.value.trim();
        if (!value) return;
        fields.push({ name: field.name, label: fieldLabel(field), value: value });
      });
      try {
        for (var index = window.sessionStorage.length - 1; index >= 0; index -= 1) {
          var key = window.sessionStorage.key(index);
          if (key && key.indexOf(storagePrefix) === 0) window.sessionStorage.removeItem(key);
        }
        window.sessionStorage.setItem(storageKey, JSON.stringify({ fields: fields }));
      } catch (error) {
        return;
      }
    }

    function restoreSubmission(submission) {
      if (!submission || !Array.isArray(submission.fields)) return;
      submission.fields.forEach(function (savedField) {
        var field = Array.prototype.find.call(form.elements, function (element) {
          return element.name === savedField.name;
        });
        if (!field || field.name === 'contact[Quote Type]') return;
        field.value = savedField.value;
      });
    }

    function showStep(number, shouldFocus) {
      currentStep = number;
      steps.forEach(function (step) {
        var active = Number(step.getAttribute('data-ae-quote-step')) === number;
        step.hidden = !active;
        step.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (errors) errors.hidden = true;
      if (shouldFocus) {
        var title = root.querySelector('[data-ae-quote-step="' + number + '"] h2');
        if (title) {
          title.setAttribute('tabindex', '-1');
          title.focus({ preventScroll: true });
        }
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      if (number === 3) updateRecap();
    }

    function showValidationErrors(invalid, message) {
      if (!invalid.length) return false;
      var invalidStep = invalid[0].closest('[data-ae-quote-step]');
      if (invalidStep) showStep(Number(invalidStep.getAttribute('data-ae-quote-step')), false);
      if (errors) {
        errors.textContent = message;
        errors.hidden = false;
        errors.focus();
      }
      invalid[0].focus();
      return true;
    }

    root.addEventListener('input', function (event) {
      if (event.target.matches('[data-ae-required]')) clearFieldError(event.target);
      updateRecap();
    });

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-ae-required]')) clearFieldError(event.target);
      updateRecap();
    });

    root.addEventListener('click', function (event) {
      var next = event.target.closest('[data-ae-quote-next]');
      var back = event.target.closest('[data-ae-quote-back]');

      if (next) {
        var current = root.querySelector('[data-ae-quote-step="' + currentStep + '"]');
        var invalid = currentStep === 1 ? validateStep(current) : [];
        if (showValidationErrors(invalid, 'Please correct the highlighted field' + (invalid.length > 1 ? 's' : '') + ' before continuing.')) return;
        showStep(Math.min(currentStep + 1, steps.length), true);
      }
      if (back) showStep(Math.max(currentStep - 1, 1), true);
    });

    form.addEventListener('submit', function (event) {
      var invalid = [];
      steps.forEach(function (step) {
        invalid = invalid.concat(validateStep(step));
      });
      if (showValidationErrors(invalid, 'Please correct the highlighted field' + (invalid.length > 1 ? 's' : '') + ' before sending your request.')) {
        event.preventDefault();
        return;
      }
      saveSubmission();
      savePendingConversion();
    });

    if (root.querySelector('[data-ae-quote-errors]:not([hidden])')) restoreSubmission(savedSubmission());
    updateRecap();
    showStep(1, false);
  }

  function start() {
    document.querySelectorAll('[data-ae-quote-form]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
